import { createContext, useContext } from 'react'

import type { ReactNode } from 'react'
import type { PenetapanPredikatKinerjaStoreState } from 'app/KinerjaShared/stores/penetapan-predikat-kinerja-store'

// Zustand store hook type - matches the actual Zustand hook signature
type ZustandStoreHook<T> = <U>(selector: (state: T) => U) => U

interface PenetapanPredikatTableContextValue {
  store: ZustandStoreHook<PenetapanPredikatKinerjaStoreState>
}

const TableContext = createContext<PenetapanPredikatTableContextValue | null>(
  null
)

export function Provider({
  children,
  store,
}: {
  children: ReactNode
  store: ZustandStoreHook<PenetapanPredikatKinerjaStoreState>
}) {
  return (
    <TableContext.Provider value={{ store }}>{children}</TableContext.Provider>
  )
}

export function usePenetapanPredikatTableStore<U>(
  selector: (state: PenetapanPredikatKinerjaStoreState) => U
): U {
  const context = useContext(TableContext)
  if (!context) {
    throw new Error(
      'usePenetapanPredikatTableStore must be used within <PenetapanPredikatTable.Provider>'
    )
  }
  return context.store(selector)
}
